import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

const Section = styled(Box)({
	marginBottom: '40px',
});

export default Section;
